import FuseLoadable from '@fuse/components/FuseLoadable/FuseLoadable'

export const AmministrazioneConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: '/amministrazione/controllo',
      component: FuseLoadable({
        loader: () => import('./ControlloGestione')
      })
    },
    {
      path: '/amministrazione/documenti',
      component: FuseLoadable({
        loader: () => import('./ControlloDocumenti')
      })
    }
  ]
}
